import React from 'react';
import { getDisputeProgress } from '../lib/disputeProgress';

// Compact dispute progress indicator: "Step X of 6 · Label" + a mini bar.
// `dark` renders for dark backgrounds (e.g. Owner Panel).
const DisputeProgressBadge = ({ dispute, dark = false }) => {
  const p = getDisputeProgress(dispute);
  if (!p) return null;

  const barFill = p.complete ? 'bg-green-500' : 'bg-orange-500';
  const track = dark ? 'bg-gray-600' : 'bg-gray-200';
  const labelColor = dark ? 'text-gray-200' : 'text-gray-700';
  const stepColor = dark ? 'text-gray-400' : 'text-gray-500';

  return (
    <div data-testid="dispute-progress-badge" className="w-full">
      <div className="flex items-center justify-between mb-1">
        <span className={`text-xs font-medium ${labelColor}`}>
          Step {p.step} of {p.total} · {p.label}
        </span>
        <span className={`text-xs ${stepColor}`}>{p.percent}%</span>
      </div>
      <div className={`h-1.5 w-full rounded-full ${track} overflow-hidden`}>
        <div
          className={`h-full rounded-full ${barFill} transition-all duration-500`}
          style={{ width: `${p.percent}%` }}
          data-testid="dispute-progress-fill"
        />
      </div>
    </div>
  );
};

export default DisputeProgressBadge;
